import React from "react";
import { Box, Typography } from "@material-ui/core";
import useStyles from "./Styles";
import useGetViewPortDimensions from "hooks/useGetViewPortDimensions";
import { useSelector } from "react-redux";
import userActions from "./actions";
// import { useHistory } from "react-router";
// import { nameParser } from "./utils";
// import CustomizedSelect from 'components/common/CustomizedSelect';
import az_map from "../../assets/arizona_map.png";
import honeycomb from "../../assets/poly_map.png";
import { chartDrawerWidth, chartTogglebarWidth } from "./Styles";

const ChartTitle = (props) => {
  const {
    setChart,
    // setSliderRange,
    // setEntitlementYear,
    // loadEntitlementsByYear,
  } = userActions();
  const { title, 
    subtitle, 
    floating, 
    // dropdown, 
    style } = props;
  const {
    // city_selected,
    // chart,
    toggle_about,
    // selectedScenario,
    // entity_dropdown,
    // polygon_map_tab,
  } = useSelector((state) => state.technical_view);
  const { loggedIn } = useSelector((state) => state.auth);

  const classes = useStyles();
  const floatingStyle = {
    ...style,
    position: "absolute",
    zIndex: 450,
    width: '96%',
    // paddingLeft:  chart === 'access_per_capita' ? 75 : 20,
    background:
      "transparent linear-gradient(180deg, rgba(239, 239, 253, 0.5) 0%, rgba(255, 255, 255, 0.5) 100%) 0% 0% no-repeat padding-box",
  };
  const nonFloatingStyle = { ...style, background: "transparent"  };
  const { isMobile } = useGetViewPortDimensions();
  // const location = useLocation();

  // useEffect(async () => {
  //   let param = new URLSearchParams(location.search);
  //   let dropdown = param.get("dropdown");
  //   // alert(dropdown)
  //   if (
  //     chart === "central_az_water_use" ||
  //     chart_name === "central_az_water_use"
  //   ) {
  //     if (
  //       central_az_tab === "irrigation_district" &&
  //       Object.keys(irrigation_districts).length > 0
  //     ) {
  //       let value =
  //         irrigation_districts.filter(
  //           (e) => e.label === nameReverseParser(dropdown)
  //         ).length > 0
  //           ? irrigation_districts.filter(
  //               (e) => e.label === nameReverseParser(dropdown)
  //             )[0]
  //           : irrigation_districts[0];
  //       setSelectedIrrigationDistrict(value); //the irrigation_districts array index is 1 below the irrigation_district value
  //     } else if (
  //       central_az_tab === "cities" &&
  //       Object.keys(cities).length > 0
  //     ) {
  //       let value =
  //         cities.filter((e) => e.label === nameReverseParser(dropdown)).length >
  //         0
  //           ? cities.filter((e) => e.label === nameReverseParser(dropdown))[0]
  //           : cities[0];
  //       let idx =
  //         cities.filter((e) => e.label === nameReverseParser(dropdown)).length >
  //         0
  //           ? cities.indexOf(
  //               cities.filter((e) => e.label === nameReverseParser(dropdown))[0]
  //                 .value + 1
  //             )
  //           : 1;
  //       // await loadCityMetrics(idx);
  //       // setSelectedCity(value);
  //     }
  //   }
  // }, [cities, irrigation_districts]);

  const handleChartChange = (value) => {
    setChart(value);
  };

  // const handleChange = (value) => {
  //   if (
  //     chart === "central_az_water_use" ||
  //     chart_name === "central_az_water_use"
  //   ) {
  //     if (
  //       central_az_tab === "irrigation_district" &&
  //       Object.keys(irrigation_districts).length > 0
  //     ) {
  //       setSelectedIrrigationDistrict(irrigation_districts.find((item) => item.value == (value))); //the irrigation_districts array index is 1 below the irrigation_district value
  //       if (loggedIn) {
  //         let dropdown = nameParser(irrigation_districts[value - 1].label);
  //         history.push({
  //           pathname: `/visualizations/doughnut`,
  //           search:
  //             "?" +
  //             new URLSearchParams({
  //               type: "irrigation_district",
  //               dropdown: dropdown,
  //             }).toString(),
  //         });
  //       }
  //     } else if (
  //       central_az_tab === "cities" &&
  //       Object.keys(cities).length > 0
  //     ) {
  //       setSelectedCity(cities.find((item) => item.value == (value)));
  //       loadCityMetrics(value);
  //       if (loggedIn) {
  //         let dropdown = nameParser(cities[value - 1].label);
  //         history.push({
  //           pathname: `/visualizations/doughnut`,
  //           search:
  //             "?" +
  //             new URLSearchParams({
  //               type: "cities",
  //               dropdown: dropdown,
  //             }).toString(),
  //         });
  //       }
  //     }
  //   } else if (chart === "colorado_river_water_access") {
  //     const city = cities.filter((item) => item.value == value)[0];
  //     setSelectedCity(cities.find((item) => item.value == (value)));      // city_selected is used on AboutTab
  //     loadEntityEntitlements(value, scenario_selected.value);
  //   } else if (chart === "water_use_versus_access") {
  //     loadCityMetrics(value);
  //     setSelectedCity(cities.find((item) => item.value == (value)));
  //     loadEntityEntitlements(value, scenario_selected.value);
  //   } else if (chart === "access_per_capita") {
  //     loadCityMetrics(value);
  //     setSelectedCity(cities.find((item) => item.value == (value)));
  //     loadEntityEntitlements(value, scenario_selected.value);
  //     loadCityWaterSources(value);
  //   }
  // };

  return (
    <Box
      className={isMobile ? classes.chartHeaderResponsive : classes.chartHeader}
      style={floating ? floatingStyle : nonFloatingStyle}
    >
      <Typography
        variant="h5"
        component="div"
        className={
          isMobile
            ? classes.chartHeaderTitleResponsive
            : classes.chartHeaderTitle
        }
      >
        {title}
      </Typography>
      {/* { // The select dropdown is not required as per product requirement
        hideDropdown.indexOf(chart) === -1 && (chart !== 'access_per_capita' || polygon_map_tab === 'per_capita') ? (
          <CustomizedSelect
            dropdownValue={selectedScenario}
            options={entity_dropdown}
            handleSelectedItem={(value, data) => {
              const [start] = data.props.value.split("-")
              setSliderRange(data.props.value)
              setEntitlementYear(start);
              loadEntitlementsByYear(start, scenario_selected.value);
            }}
            disabled={false}
          />
        ) : null
      } */}
      
      <Typography
        variant="body1"
        component="p"
        className={
          isMobile
            ? classes.chartHeaderSubtitleResponsive
            : classes.chartHeaderSubtitle
        }
      >
        {subtitle}
      </Typography>
      {/* {(chart === "central_az_water_use" ||
        chart_name === "central_az_water_use") &&
        !isMobile && (
          <CentralAZLocationFilter
            //dougnut
            location_options={
              central_az_tab === "irrigation_district"
                ? irrigation_districts
                : cities
            }
            handleChange={handleChange}
            style={{ marginRight: 24, background: 'white', borderRadius: '5px'}}
            autocomplete={true}
            city_id={city_selected.city_id} 
          />
        )} */}
        {/* Location filter moved to sidebar */}
      {(title === "Colorado River Water Access" ||
        title === "Central Arizona Colorado River Water Access Per Person - Municipal Areas") &&
        !loggedIn &&
        !isMobile && (
          <Box className={classes.mapTitleBox}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              className={classes.mapFilterChips}
              style={{
                // backgroundColor: irrigationSelected ? "#EBF0FD" : "#FFFFFF",
                backgroundColor: "#FFF",
                width: "40px",
                marginRight: 5,
              }}
              onClick={() => handleChartChange("colorado_river_access")}
            >
              <img
                className={classes.mapFilterChipIcon}
                style={{
                  height: "18px",
                  // marginRight: "10px",
                  background: "blue",
                }}
                src={
                  // irrigationSelected
                  //   ? chip_irrigation_highlight
                  //   : chip_irrigation_icon
                  az_map
                }
                alt="chip-icon.png"
              />
            </Box>

            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              className={classes.mapFilterChips}
              style={{
                // backgroundColor: irrigationSelected ? "#EBF0FD" : "#FFFFFF",
                backgroundColor: "#FFF",
                width: "40px",
                marginRight:
                  title === "Colorado River Access"
                    ? toggle_about
                      ? chartDrawerWidth + 50
                      : chartTogglebarWidth + 90
                    : 10,
              }}
              onClick={() => handleChartChange("access_per_capita")}
            >
              <img
                className={classes.mapFilterChipIcon}
                style={{
                  height: "18px",
                  // marginRight: "10px",
                  backgroundColor: "blue",
                }}
                src={
                  // irrigationSelected
                  //   ? chip_irrigation_highlight
                  //   : chip_irrigation_icon
                  honeycomb
                }
                alt="chip-icon.png"
              />
            </Box>
          </Box>
        )}
      {/* {chart === "access_per_capita" && !isMobile && (
        <CentralAZLocationFilter
          // Honey Comb
          location_options={cities}
          handleChange={handleChange}
          style={{ marginRight: 24, background: 'white', borderRadius: '5px'}}
          autocomplete={true}
          city_id={city_selected.city_id} 
        />
      )} */}
      {/* Location filter moved to sidebar */}
      {/* {chart === "colorado_river_water_access" &&
        area_chart_tab.value == 2 &&
        !isMobile && (
          <CentralAZLocationFilter
            // Area
            location_options={cities}
            handleChange={handleChange}
            style={{ marginRight: 24, background: 'white', borderRadius: '5px'}}
            autocomplete={true}
            city_id={city_selected.city_id} 
          />
        )} */}
      {/* Location filter moved to sidebar */}
      {/* {chart === "water_use_versus_access" && !isMobile && (
        <CentralAZLocationFilter
          // Guage
          location_options={cities}
            handleChange={handleChange}
            style={{ marginRight: 24, background: 'white', borderRadius: '5px'}}
            autocomplete={true}
            city_id={city_selected.city_id} 
        />
      )} */}
      {/* Location filter moved to sidebar */}
    </Box>
  );
};

ChartTitle.defaultProps = {
  title: "Chart Title",
  subtitle: "Big River Policy Name",
  floating: false,
  dropdown: "Phoenix",
  type: "cities",
};

export default ChartTitle;
